import React from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { ActionCard, PageHeader } from "../../components/v3";

export const Libraries = () => {
  const navigate = useNavigate();

  const handleCardClick = (index) => {
    const item = cardData[index];
    if (item.route) {
      navigate(item.route);
    } else {
      console.log("No route defined for this card:", item);
    }
  };

  const cardData = [
    {
      title: "Expense Categories",
      subheader: "Manage your expense categories",
      route: "/library/expense-categories",
    },
    {
      title: "Materials",
      subheader: "Manage your materials",
      route: "/library/materials",
    },
    {
      title: "Stages",
      subheader: "Manage your stages",
      route: "/library/stages",
    },
  ];
  return (
    <PageLayout>
      {/* header section */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader
          // title
          title="Library"
        />
      </Box>

      {/* show all libraries as cards */}
      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <ActionCard cardData={cardData} onCardClick={handleCardClick} />
      </Box>
    </PageLayout>
  );
};
